<template id="flow-template">
  <div class="homeview-realtime-data">
    <div class="flowCircleOne">
        <div class="circle-chart ">
          <div
            class="task-item"
            v-bind:class="{ item2: index == 0, item4 :index ==1}"
            v-for="(item,index) in realtimeData"
            :key="index"
          >
            <div class="task-icon-wrapper">
              {{item.total}}
              <div class="task-icon"></div>
            </div>
            <div class="task-status">{{item.name}}</div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import { getTotal } from "../../../apis/src/Query";
export default {
  name: "projectLeft",
  componentName: "projectLeft",
  components: {},
  props: {},
  data() {
    return {
      realtimeData: [
        {
          name:"项目资料",
          total:""
        },
        {
          name:"设计图纸",
          total:""
        }
      ]
    };
  },
  created() {
    this.getTList();
  },
  mounted() {
  },
  methods: {
    showLoading(text) {
        this.$emit('loading', text);
      },
    hideLoading() {
      this.$emit('loadingFinish');
     },
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
     getTList(type) {
        this.showLoading('加载中...');
        getTotal({}).then(res =>{
          console.log(res)
          this.hideLoading();
          if(res.code == 200){
            this.realtimeData[0].total = res.rows[0].totalDocs
            this.realtimeData[1].total = res.rows[0].totalDrawings
          }else{
            this.errmsg(res.msg? res.msg : "服务异常，请联系管理员！");
          }
        })
    }
   
  },
  beforeDestroy() {},
  destroyed() {},
};
</script>
<style lang="scss" scoped>
div.flowCircleOne{ 
  padding-top:5%;
}

.table_box{
      height:300px;
      overflow: auto;
      margin-top:30px;
  }
</style>